<div *ngIf="materials$ | async" class="h-full w-full flex flex-row gap-4 items-start" fusePerfectScrollbar>
  <div class="p-4 h-full flex flex-col items-stretch basis-128" fusePerfectScrollbar>
    <!-- <cutting-sizes [panel]="editedPanel" [disabled]="disabled" #sizes></cutting-sizes> -->

    <csl-facade-settings
      #settings
      [disabled]="disabled"
      [userId]="userId"
      [panel]="editedPanel"
      [cuttingSettings]="cuttingSettings"
      [componentsAvailability]="componentsAvailability"
      [currencySymbol]="getCurrencySymbol()">
      <div class="flex flex-row gap-x-2 items-start">
        <button
          *ngIf="!editMode"
          mat-raised-button
          color="accent"
          (click)="addPanel()"
          data-testid="facadeAdd"
          [disabled]="disabled || !editedPanel?.material || !settings.valid || isExistFilmMaterialsWithoutFilm"
          i18n
          class="flex-1"
          >ДОБАВИТЬ</button
        >

        <ng-container *ngIf="editMode">
          <button
            mat-raised-button
            color="accent"
            [disabled]="!editedPanel?.material || !settings.valid"
            i18n
            (click)="savePanel()"
            class="flex-1"
            >СОХРАНИТЬ</button
          >
          <button mat-raised-button (click)="stopEditMode()" i18n class="flex-1">ОТМЕНА</button>
        </ng-container>
      </div>
    </csl-facade-settings>
  </div>

  <div class="h-full flex flex-col items-stretch flex-1" fusePerfectScrollbar>
    <div class="my-4 flex flex-row items-stretch basis-90">
      <csl-panel-texture-settings
        [panel]="editedPanel"
        [userId]="userId"
        [disabled]="editedPanel?.material?.film"
        (change)="changeTextureDirection($event.changedDirectionPanel)">
      </csl-panel-texture-settings>

      <div fusePerfectScrollbar class="flex flex-col items-start flex-1">
        <cutting-panel-schema [panel]="editedPanel" class="m-auto"></cutting-panel-schema>
      </div>
    </div>

    <mat-divider> </mat-divider>

    <div fusePerfectScrollbar class="panel-list flex flex-row items-stretch">
      <cutting-panel-list
        [disabled]="disabled"
        [panels]="panels"
        [cuttingSettings]="cuttingSettings"
        (editing)="edit($event)"
        [editMode]="editMode"
        class="flex-1">
      </cutting-panel-list>
    </div>
  </div>
</div>
